import { DataProp } from 'editorjs-blocks-react-renderer';

// eslint-disable-next-line react-refresh/only-export-components
export const toJSON = (string: string) => {
  try {
    return JSON.parse(string);
  }
  catch (e) {
    return string || '';
  }
};

// eslint-disable-next-line react-refresh/only-export-components
export function isDataProp(description: any): description is DataProp {
  return description?.blocks?.length > 0;
}

export type { DataProp };

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

// eslint-disable-next-line react-refresh/only-export-components
export const formatPrice = (price?: number | null) => USD_FORMATTER.format(price ?? 0);

// eslint-disable-next-line react-refresh/only-export-components
export const toLetter = (idx: number) => (idx + 10).toString(36).toUpperCase();
